module.exports = __webpack_public_path__ + "img/4.c36ff2e5.jpg";